import React, { createContext, useContext, useEffect, useState } from 'react';
import api from '../api/axios';
import { mediaUrl } from '../config/environment';

const SettingsContext = createContext();

export function resolveMedia(path) {
  return mediaUrl(path);
}

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState(null);

  const fetchSettings = async () => {
    try {
      const { data } = await api.get('/settings/public');
      setSettings(data);
      if (data.favicon) {
        const link = document.getElementById('favicon');
        if (link) link.href = resolveMedia(data.favicon);
      }
      if (data.siteName) {
        document.title = `${data.siteName} - ${data.tagline || ''}`;
      }
    } catch (e) {
      // Backend may not be running yet; fall back to defaults silently
    }
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  return (
    <SettingsContext.Provider value={{ settings, refreshSettings: fetchSettings }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);
